import React from 'react';
import PropTypes from 'prop-types';
import { WithIconRounded } from 'Components/ProfileMultiProduct/components/designSystem';

const DownIcon = ({
  className,
  color,
  containerColor,
  containerSize,
  onClick,
  round,
  size,
}) => (
  <WithIconRounded
    round={round}
    containerColor={containerColor}
    containerSize={containerSize}
    className={className}
    onClick={onClick}
  >
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.99999 3.78047L8.29999 0.480469L9.24266 1.42314L4.99999 5.6658L0.757324 1.42314L1.69999 0.480469L4.99999 3.78047Z"
        fill={color}
      />
    </svg>
  </WithIconRounded>
);

DownIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  containerColor: PropTypes.string,
  containerSize: PropTypes.number,
  onClick: PropTypes.func,
  round: PropTypes.bool,
  size: PropTypes.number,
};

DownIcon.defaultProps = {
  className: 'k-ds-text-color-alternate',
  color: 'var(--k-ds-color-text-primary)',
  containerColor: null,
  containerSize: 40,
  onClick: null,
  round: false,
  size: 16,
};

export default DownIcon;
